/* unplugin-vue-components disabled */import { render } from "./password-expiry-gate.vue?vue&type=template&id=137b6db2&scoped=true"
import script from "./password-expiry-gate.vue?vue&type=script&lang=js"
export * from "./password-expiry-gate.vue?vue&type=script&lang=js"

import "./password-expiry-gate.vue?vue&type=style&index=0&id=137b6db2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-137b6db2"]])

export default __exports__